module.exports = __webpack_public_path__ + "img/bell_refund.b9fbe3b0.png";